module.exports = __webpack_public_path__ + "img/f1car.74dcea33.png";